import script from "./GroupRankView.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupRankView.vue?vue&type=script&setup=true&lang=js"

import "./GroupRankView.vue?vue&type=style&index=0&id=0e1362df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e1362df"]])

export default __exports__